import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { CallRecordingExtensionsListComponent } from './call-recording-extensions-list.component';

@NgModule({
   exports: [CallRecordingExtensionsListComponent],
   declarations: [CallRecordingExtensionsListComponent],
   imports: [
      CommonModule,
      MatCheckboxModule,
      MatFormFieldModule,
      FormsModule,
      ReactiveFormsModule,
      MatInputModule,
      MatIconModule,
      ScrollingModule,
   ],
})
export class CallRecordingExtensionsListModule {}
